module.exports = __webpack_public_path__ + "img/screen-support.b114dea7.png";